import React from 'react';
import { Box, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, TableContainer } from '@mui/material';

const mockData = [
  { agent: 'John Doe', source: 'Google Ads', totalLeads: 35, hot: 6, warm: 12, cold: 10, closedWon: 4, lost: 3 },
  { agent: 'Jane Smith', source: 'Walk-in', totalLeads: 20, hot: 4, warm: 7, cold: 6, closedWon: 2, lost: 1 },
  { agent: 'Rahul Kumar', source: 'Channel Partner', totalLeads: 28, hot: 5, warm: 9, cold: 8, closedWon: 3, lost: 3 },
];

const AgentLeadSourceStatusReportPage = () => {
  return (
    <Box sx={{ flexGrow: 1, pt: 0, pb: 3, px: { xs: 2, sm: 3 } }}>
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 'bold', color: 'text.primary', mb: 0.5 }}
        >
          Agent Lead Source Status Report
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Lead status breakdown by agent and acquisition source.
        </Typography>
      </Box>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 2,
          boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
        }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Agent</TableCell>
              <TableCell>Lead Source</TableCell>
              <TableCell align="right">Total Leads</TableCell>
              <TableCell align="right">Hot</TableCell>
              <TableCell align="right">Warm</TableCell>
              <TableCell align="right">Cold</TableCell>
              <TableCell align="right">Closed Won</TableCell>
              <TableCell align="right">Lost</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mockData.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.agent}</TableCell>
                <TableCell>{row.source}</TableCell>
                <TableCell align="right">{row.totalLeads}</TableCell>
                <TableCell align="right">{row.hot}</TableCell>
                <TableCell align="right">{row.warm}</TableCell>
                <TableCell align="right">{row.cold}</TableCell>
                <TableCell align="right">{row.closedWon}</TableCell>
                <TableCell align="right">{row.lost}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AgentLeadSourceStatusReportPage;


